import React, { useState, useRef } from 'react';
import { SwivuMenu } from './SwivuMenu.jsx';
import { classNameHelper } from '../../other/utils/utils.jsx';

export function SwivuContextMenu({
  options = {},
  className = "",
  icon,
  text,
  buttonClassName = ""
}) {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);

  const menuOptions = Object.entries(options)
    .map(([key, option]) => ({
      ...option,
      id: key,
      onClick: (optionData) => {
        option.onClick?.(key, optionData);
        setIsOpen(false);
      }
    }));

  const handleButtonClick = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        type="button"
        onClick={handleButtonClick}
        className={classNameHelper(
          "p-2 rounded-lg hover:bg-secondary transition-colors font-swivu-modern text-base cursor-pointer bg-transparent border-0",
          buttonClassName
        )}
        aria-label="Open menu"
      >
       <i className={classNameHelper("text-muted-foreground", icon || "fas fa-ellipsis-v")}></i> {text}
      </button>

      <SwivuMenu
        options={menuOptions}
        isOpen={isOpen}
        onItemClick={(option) => option.onClick?.(option)}
        onClose={handleClose}
        className={className}
      />
    </div>
  );
}
